import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users/model/types';
import { V2ModeSettings } from '~pages/v2-mode/index';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/v2-mode')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: V2ModeSettings,
});
